import { useNavigate } from 'react-router-dom'
import { useWorlds } from '@/hooks/useWorlds'
import { AppLayout } from '@/components/layout/AppLayout'
import { AdminOnly } from '@/components/AdminOnly'
import { WorldCard } from '@/components/world/WorldCard'
import { WorldCardSkeleton } from '@/components/world/WorldCardSkeleton'
import { Button } from '@/components/ui/button'

export default function WorldList() {
  const navigate = useNavigate()
  const { worlds, isLoading, error } = useWorlds()

  return (
    <AppLayout breadcrumbs={[{ label: 'Worlds' }]}>
      <div className="mb-8 flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold">Worlds</h1>
          <p className="text-muted-foreground mt-1">Browse available game worlds</p>
        </div>
        <AdminOnly>
          <Button onClick={() => navigate('/worlds/new')}>Create World</Button>
        </AdminOnly>
      </div>

      {error && (
        <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-red-800">
          Failed to load worlds. Please try again later.
        </div>
      )}

      {isLoading && (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {[1, 2, 3].map((i) => (
            <WorldCardSkeleton key={i} />
          ))}
        </div>
      )}

      {!isLoading && !error && worlds && worlds.length === 0 && (
        <div className="rounded-lg border border-dashed p-12 text-center">
          <h3 className="text-lg font-medium">No worlds yet</h3>
          <p className="text-muted-foreground mt-1">
            There are no game worlds available at the moment.
          </p>
          <AdminOnly>
            <Button className="mt-4" onClick={() => navigate('/worlds/new')}>
              Create the first world
            </Button>
          </AdminOnly>
        </div>
      )}

      {!isLoading && !error && worlds && worlds.length > 0 && (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {worlds.map((world) => (
            <WorldCard key={world.id} world={world} />
          ))}
        </div>
      )}
    </AppLayout>
  )
}
